import React from "react";

const ManageQuiz = React.lazy(() => import("./manage-quiz"));
const AddQuestion = React.lazy(() => import("./question"));

export {
  ManageQuiz,
  AddQuestion,
};
